import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

const UpcomingEventsSection = () => {
  const [events, setEvents] = useState([]);
  const fetchUpcomingEvents = async () => {
    try {
      const response = await corefetch("UpcomigEvents/GetUpcomingEventsList");
      if (response && response.length > 0) {
        setEvents(response);
      } else {
        setEvents([]);
        console.error("No events found");
      }
    } catch (error) {
      setEvents([]);
      console.error("Failed to fetch events", error);
    }
  };

  useEffect(() => {
    fetchUpcomingEvents();
  }, []);

  // useEffect(() => {
  //   if ($(".wpo-testimonial-wrap").length) {
  //     $(".slider-for").slick({
  //       slidesToShow: 1,
  //       slidesToScroll: 1,
  //       arrows: false,
  //       fade: true,
  //       asNavFor: ".slider-nav",
  //       dots: false,
  //       autoplay: true,
  //       autoplaySpeed: 3000,
  //       responsive: [
  //         {
  //           breakpoint: 1231,
  //           settings: {
  //             dots: false,
  //           },
  //         },
  //       ],
  //     });
  //     $(".slider-nav").slick({
  //       slidesToShow: 1,
  //       slidesToScroll: 1,
  //       asNavFor: ".slider-for",
  //       focusOnSelect: true,
  //       arrows: false,
  //       dots: false,
  //       autoplay: true,
  //       autoplaySpeed: 3000,
  //       responsive: [
  //         {
  //           breakpoint: 1231,
  //           settings: {
  //             dots: false,
  //           },
  //         },
  //       ],
  //     });
  //   }
  // }, [JSON.stringify(events)]);

  if (!events || events.length == 0) {
    return null;
  }

  return (
    <section className="wpo-portfolio-section section-padding">
      <div className="container">
        <div className="wpo-section-title">
          <h4>Upcoming Events</h4>
          <h2>At Meridian Convention Center</h2>
        </div>
        <div className="wpo-testimonial-wrap">
          <div className="row align-items-center">
            <div
              className="col col-md-12 wow fadeInLeftSlow"
              data-wow-duration="1700ms"
            >
              <div
                id="eventCarousel"
                className="carousel slide"
                data-bs-ride="carousel"
                data-bs-interval={3000}
              >
                <div className="carousel-inner">
                  {events?.map((event, index) => (
                    <div
                      key={event.upcomingEventsID}
                      className={`carousel-item ${index === 0 ? "active" : ""}`}
                    >
                      <div className="row justify-content-center">
                        <div className="col-md-8 text-center">
                          <div className="event-img">
                            <img
                              src={`${ImageURL}${event.imagePath}`}
                              alt={event.title}
                              className="img-fluid"
                            />
                          </div>
                          <div className="wpo-testimonial-texts">
                            <div className="wpo-testimonial-text-btms">
                              <h3>{event.title}</h3>
                              <span>
                                @{event.ballroomName} -{" "}
                                {new Date(event.eventDate)
                                  .toLocaleDateString("en-US", {
                                    month: "short",
                                    day: "2-digit",
                                    year: "numeric",
                                  })
                                  .toUpperCase()}{" "}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#eventCarousel"
                  data-bs-slide="prev"
                >
                  <span
                    className="carousel-control-prev-icon"
                    aria-hidden="true"
                  />
                  <span className="visually-hidden">Previous</span>
                </button>
                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#eventCarousel"
                  data-bs-slide="next"
                >
                  <span
                    className="carousel-control-next-icon"
                    aria-hidden="true"
                  />
                  <span className="visually-hidden">Next</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UpcomingEventsSection;
